import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

const scheduleService = (action: any) => {
  return {
    getSchedule: () =>
      apiClient.get(
        `${API_BASE_ADDRESS}/visitor/yoyaku/schedule-search?clubCode=${action.clubCode}&imageDate=${
          action.imageDate
        }&programId=${action.programId || ''}`,
      ),
    getReserveConfirmData: () =>
      apiClient.get(
        `${API_BASE_ADDRESS}/visitor/yoyaku/contents-reservation?contentsId=${action.contentsId}&clubId=${action.clubId}&contentsDate=${action.contentsDate}&startTime=${action.startTime}&endTime=${action.endTime}`,
      ),
  };
};

export default scheduleService;
